import React, { Component } from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/style.css';
import { Link } from 'react-router-dom';
import Header from './Header';
import profileImg from '../assets/images/account-info/profile-picture.png';
import editIcon from '../assets/images/account-info/edit-profile-pic-icon.svg';
import plusIcon from '../assets/images/account-info/add-social-media-icon.svg';
import instaIcon from '../assets/images/account-info/instagram.png';
import facebookIcon from '../assets/images/account-info/facebook.png';
import twitterIcon from '../assets/images/account-info/twitter.png';
import youtubeIcon from '../assets/images/account-info/youtube.svg';
import discordIcon from '../assets/images/account-info/discord.svg';
import redditIcon from '../assets/images/account-info/reddit.svg';
import twitchIcon from '../assets/images/account-info/twitch.png';

class AccountInfo extends Component {
    render() {
        return (
            <div className="main-wrapper">
                 {/* Header area start */}
                 <Header />
                {/* Header area end */}

                {/* Account Info area start */}
                <hr />
                <div className="container mb-5">
                    <div className="row justify-content-center">
                        <div className="col-lg-6 col-sm-12 text-center account-area">
                            <h1>Account Info</h1>
                            <div className="account-profile">
                                <img src={profileImg} alt="profile-pic" />
                                <img src={editIcon} className="edit-icon" alt="" />
                            </div>
                            <div className="text-left account-input-area">
                                <h4>Email Address</h4>
                                <input type="email" placeholder="myemail@address.com" required />
                                <h4>Username</h4>
                                <input type="text" placeholder="myusername" required />
                                <h6>lorem.com/@username</h6>
                                <Link to="#">Copy Link</Link>
                                <h3>Profile Bio</h3>
                                <div className="form-group profile-bio">
                                    <textarea className="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
                                </div>
                                <Link className="save-changes" to="#">Save Changes</Link>&emsp;
                                <Link className="discard-changes" to="#">Discard Changes</Link>
                                <h4>Social Media&emsp;<Link to="#"><img className="plus-icon" src={plusIcon} alt="" /></Link></h4>
                                <Link to="#"><img className="social-icon" src={instaIcon} alt="Instagram" /></Link>
                                <Link to="#"><img className="social-icon" src={facebookIcon} alt="Facebook" /></Link>
                                <Link to="#"><img className="social-icon" src={youtubeIcon} alt="Youtube" /></Link>
                                <Link to="#"><img className="social-icon" src={twitterIcon} alt="Twitter" /></Link>
                                <Link to="#"><img className="social-icon" src={discordIcon} alt="Discord" /></Link>
                                <Link to="#"><img className="social-icon" src={redditIcon} alt="Reddit" /></Link>
                                <Link to="#"><img className="social-icon" src={twitchIcon} alt="Twitch" /></Link>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Account Info area end */}
            </div>
        )
    }
};

export default AccountInfo;